import { render, staticRenderFns } from "./pen.vue?vue&type=template&id=669ed681&scoped=true&"
import script from "./pen.vue?vue&type=script&lang=js&"
export * from "./pen.vue?vue&type=script&lang=js&"
import style0 from "./pen.vue?vue&type=style&index=0&id=669ed681&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ed681",
  null
  
)

export default component.exports